import { render, staticRenderFns } from "./SampleNewModal.vue?vue&type=template&id=15639e22&"
import script from "./SampleNewModal.vue?vue&type=script&lang=js&"
export * from "./SampleNewModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports